import { TaskSheet } from '@/models/task-sheets'
import type { TTemplatesState } from '@/types/state-types/TTemplatesState'

export default <TTemplatesState>{
  templateForm: new TaskSheet(),
  isTemplateFormLoading: false,
  selectedTemplate: { ...new TaskSheet(), isLoading: false },
  deletingTemplates: false,
  tempTemplate: new TaskSheet(),
}
